import React,{useState,useEffect} from 'react'

const ContainerCard = ({children,name,data}) => {
    
    const [view,setView] = useState(false)
    
    useEffect(() => {

        setView(true)


    },[])

    return(

        <div className='container_card'>
            {view == false 
            
            ?
            <></>
            :
            <>
            <p>{name}</p>
            {children}
            </>
            }

        </div>

    )
}

export default ContainerCard